import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Lasso = createReactComponent("Lasso", ["svg", defaultAttributes, [["path", {
  d: "M7 22a5 5 0 01-2-4",
  key: "16rap9"
}], ["path", {
  d: "M3.3 14A6.8 6.8 0 012 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 01-5-1",
  key: "9ulfy8"
}], ["path", {
  d: "M5 18a2 2 0 100-4 2 2 0 000 4z",
  key: "1rvba9"
}]]]);
export default Lasso;